import { Link } from "react-router-dom";
import constants from "../../constants/constants";
import "./BlogsPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

export default function BlogsPage() {
  return (
    <>
      <div className="blogs-page-container">
        <header className="blogs-intro">
          <p>Blogs</p>
          <h1>Real Estate News & Insights</h1>
          <p>Expert insights, market trends, and practical advice to help you make smarter property decisions.</p>
        </header>
        <main className="blogs-main">
          {constants.blogs.map((blog, index) => (
            <article className="blog-card" key={index}>

              <Link to={`/blog/${blog.slug}`} className="blog-card-image">
                <img
                  src={blog.image}
                  alt={blog.title}
                  loading="lazy"
                />
              </Link>

              <div className="blog-card-content">

                <span className="blog-card-category">
                  {blog.category}
                </span>

                <h2 className="blog-card-title">
                  <Link to={`/blog/${blog.slug}`}>
                    {blog.title}
                  </Link>
                </h2>

                <p className="blog-card-excerpt">
                  {blog.excerpt}
                </p>

                <div className="blog-card-footer">
                  <div className="blog-card-meta">
                    <FontAwesomeIcon icon={faCalendar} />
                    <span>{blog.publishedAt}</span>
                  </div>

                  <Link
                    to={`/blog/${blog.slug}`}
                    className="blog-card-link"
                  >
                    Read Article →
                  </Link>

                </div>

              </div>

            </article>
          ))}
        </main>
      </div>
    </>
  )
}